import { Col, Row, Space, Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { FC } from "react";


const SummaryItem:FC<{src:string,title:string,value:number,suffix:string}> = ({ src, title, value, suffix }) => 

   {
    const {Text} = Typography
    return  (

        <Col xs={24} md={12} lg={8}>
          <Row className="!bg-white shadow-lg p-4 rounded-md !h-[110px] !flex items-center">
            <Col xs={14} md={12} lg={18}>
              <div>
                <Text className="!text-[#6E7583]">{title}</Text>
              </div>
              <div>
                <Space>
                  <Text className="!text-2xl !font-bold">{value||0} </Text>
                  <span>{suffix}</span>
                </Space>
              </div>
            </Col>
            <Col xs={10} md={12} lg={6} className="!flex justify-end items-center">
              <LazyLoadImage wrapperWidth="40px" wrapperHeight="40px" alt="" src={src} />
            </Col>
          </Row>
        </Col>
      );
    
   }
  export default SummaryItem
  